<template lang="pug">
.dawn-primary-nav-wrapper
  //- TABS
  .dawn-primary-nav
    .container-fluid
      span.logo
        img(src='~images/../logo.svg')
      span.dawn-primary-nav-toggle(v-on:click='toggleMenu')
        i.fa.fa-bars
      ul.primary-nav-menu(v-bind:class='[menuClosed ? hideMenu : !menuClosed, showMenu]')
        li.primary-nav-item-wrapper(v-for='(item, index) in items' :key='index' v-if='item.permissions')
          router-link.primary-nav-item(:to='{path: item.path}' tag='span' active-class='active') {{item.name}}
  //- SUBTABS
  .dawn-seconday-nav(v-if='subNav')
    .container-fluid
      ul.secondary-nav-menu
        li.secondary-nav-item-wrapper(v-for='(item, index) in subNav') :key='index'
          router-link.secondary-nav-item(:to='{path: item.path}' tag='span' active-class='active') {{item.name}}
</template>

<script>

export default {
  name: 'ed-primary-nav',
  data () {
    return {
      menuClosed: false,
      showMenu: 'nav-menu-show',
      hideMenu: 'nav-menu-hide',
      active: 'active',
      items: [],
      activeParentLink: {}
    }
  },
  methods: {
    toggleMenu () {
      this.menuClosed = !this.menuClosed
    }
  },
  created () {
    this.$router.options.routes.forEach(route => {
      if (route.meta) {
        this.items.push({
          name: route.name,
          path: route.path
        })
      }
    })
  },
  computed: {
    subNav () {
      const found = this.$router.options.routes.find((route) => {
        return route.name === this.$route.matched[0].name
      })
      if (found) {
        return found.children
      }
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.dawn-primary-nav {
  display: block;
  width: 100%;
  padding: 1.5rem $side-padding 0rem;
  position: relative;
  border-bottom: 4px solid;
  box-shadow: $box-shadow;
  font-size: $font-size-medium;
  color: $background-light;
  background: $primary-04;

  span.dawn-primary-nav-toggle {
    padding: 0rem .3rem;
    border: 2px solid;
    border-radius: $border-radius;
    font-size: 1.5rem;
    position: absolute;
    right: 1rem;
    top: .75rem;
    display: block;
    transition: all .3s ease-out;
    color: $canvas;
    background: $primary-04;

    &:hover {
      cursor: pointer;
      opacity: .8;
      color: $canvas;
      border-color: $canvas;
    }

    @include media(">tablet") {
      display:none;
    }
  }

  ul.primary-nav-menu {
    display: inline-block;
    list-style: none;
    padding: 0;
    position: absolute;
    right: $side-padding;
    bottom: 0;
    margin-bottom: 0;

    li.primary-nav-item-wrapper {
      display: inline-block;

      span.primary-nav-item {
        display: block;
        margin: 0rem .1rem;
        padding: .8rem 1.5rem;
        border-radius: 3px 3px 0px 0px;
        transition: all .3s ease-out;
        background: $primary-02;
        color: $canvas;

        &:hover, &.active {
          background: $background-light;
          color: $primary-04;
          cursor:pointer;
        }
      }
    }

    div.primary-nav-dropdown {
      position: absolute;
      top: -.15rem;
      left: 1rem;
      box-shadow: $box-shadow;
      padding: 0rem 1rem 1rem 1rem;
      width: 100%;
      background: $canvas;

      ul.primary-nav-dropdown-menu {
        list-style: none;
        padding: 0;

        li.primary-nav-dropdown-title {
          font-weight: $font-weight-bold;
          margin-bottom: .3rem;
          color: $primary-04;

          span.close-icon {
            font-weight: 100;
            margin-left: 2rem;
            color: $ink;
            &:hover {
              cursor: pointer;
            }
          }
        }

        li.primary-nav-dropdown-item {
          border-radius: $border-radius;
          padding: .3rem 0rem;
          a {
            padding: .5rem;
            opacity: 1;
            font-size: $font-size-small;
            line-height: 1rem;
            color: $primary-04;
          }

          &:hover {
            background: $background-light;
            transition: all .5s ease-out;
          }
        }
      }
    }

    @include media("<tablet") {
      padding: 1rem;
      overflow-y: auto;
      top: 3.5rem;
      left: 0;
      right: 0;
      height: 70vh;
      box-shadow: $box-shadow;
      background: $background-light;

      &.nav-menu-show {
        display: block;
        z-index: 99999;
      }

      &.nav-menu-hide {
        display: none;
      }

      li.primary-nav-item-wrapper {
        display:block;

        span.primary-nav-item {
          display: block;
          margin: .5rem;
          padding: .8rem 1.5rem;
          border-radius: $border-radius;
          transition: all .3s ease-out;
          color: $canvas;

          &:hover, .active {
            background: $primary-04;
            color: $canvas;
            cursor:pointer;
          }
        }
      }
    }
  }
}

.dawn-secondary-nav {
  position: relative;
  display: block;
  padding: .4rem 1rem .7rem 1rem; 
  font-size: $font-size-xsmall;
  font-weight: $font-weight-bold;
  text-transform: uppercase;
  box-shadow: $box-shadow;
  line-height: 1;
  background: $background-light;
}

ul.secondary-nav-menu {
  list-style: none;
  padding: 0;
  position: relative;
  display: inline-block;
  margin-bottom: 0rem;

  li.secondary-nav-item-wrapper {
    display: inline-block;

    span.secondary-nav-item {
      display: block;
      margin: 0rem .1rem;
      padding-right: 2rem;
      transition: all .3s ease-out;
      font-size: $font-size-xsmall;
      line-height: 1;
      color: $background;

      &:hover, &.active  {
        color: $ink;
        cursor: pointer;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/core/components/edPrimaryNav/index.vue